import { Component, ElementRef, OnDestroy, OnInit, Renderer2 } from '@angular/core';
import { NotificationMessageService } from 'src/app/shared/notification-message/notification-message.service';
import { SitesService } from 'src/app/sites/sites.service';
import { ChargerSettingsSetpValue, ChargersUtilizationSettings, UtilizationSettingType } from '../site-utilization-settings.interface';
import { Subscription } from 'rxjs';
import { CommonService } from 'src/app/shared/services/common.service';
import { ActivatedRoute } from '@angular/router';

@Component({
	selector: 'app-chargers-utilization-settings',
	templateUrl: './chargers-utilization-settings.component.html',
	styleUrls: ['./chargers-utilization-settings.component.css']
})

export class ChargersUtilizationSettingsComponent implements OnInit, OnDestroy {
	siteId: number;
	disableButton: boolean = false;
	settingType: UtilizationSettingType = UtilizationSettingType.Charger;
	chargerStepValues = ChargerSettingsSetpValue;
	subSite: Subscription = new Subscription();

	chargerSettings: ChargersUtilizationSettings = {
		min_daily_charge_operating_minutes: 30,
		min_daily_charge_utilization: 20,
		min_daily_charge_ah_utilization: 20,
		min_daily_charge_kwh_utilization: 20,
		max_disconnect_days: 5,
		minimum_charger_daily_ahr_usage: 100,
		minimum_charger_daily_kwh_usage: 2,
		maximum_charger_daily_kw_demand: 5,
		low_disconnect_range_min: 7,
		low_disconnect_range_max: 15,
		mid_disconnect_range_min: 16,
		mid_disconnect_range_max: 30,
		high_disconnect_limit: 31,
		geofence_distance: 5000,
	};

	selectedDays: number[] = [0, 1, 2, 3, 4]; // Days Monday TO Friday ==> checked By Default
	workingDays = this.commonService.workingDays;

	constructor(
		private siteService: SitesService,
		private elementRef: ElementRef,
		private render: Renderer2,
		private route: ActivatedRoute,
		private notificationService: NotificationMessageService,
		private commonService: CommonService
	) {}

	ngOnInit() {
		this.siteId = Number(this.route.parent.snapshot.params.siteId);
		this.subSite = this.siteService.siteUtilizationSettingsData.subscribe((data:any) => {
			if (data.charger_utilization_settings && Object.keys(data.charger_utilization_settings).length) {
				this.selectedDays = data.charge_utilization_working_days;
				return this.chargerSettings = data.charger_utilization_settings;
			}
		});
	}

	saveSiteChargerUtilizationSettings() {
		let invalidInputs = this.elementRef.nativeElement.querySelectorAll('.invalid-input');
		invalidInputs.forEach((item) => {
			item.classList.remove('invalid-input');
		});

		this.siteService.saveSiteUtilizationSettings(this.siteId, this.settingType, this.chargerSettings, this.selectedDays).subscribe((res: any) => {
			if (res && res?.length) {
				return this.notificationService.setMessage('globalSuccessMsg');
			} else {
				return this.notificationService.setMessage('globalErrMsg');
			}
		});
	}

	validateInputs() {
		let isValid = true;
		for (const field in this.chargerSettings) {
			const newValue = this.chargerSettings[field];
			const ele = this.elementRef.nativeElement.querySelectorAll(`[name=${field}]`);
			if (ele.length > 0) {
				this.render.removeClass(ele[0], 'invalid-input');
			}

			if (newValue == null || newValue == undefined || isNaN(newValue)) {
				this.handleInvalidInputs(field);
				isValid = false;
				continue;
			}

			switch(field) {
				case 'min_daily_charge_operating_minutes':
					if (newValue < 0 || newValue % 15 != 0) {
						this.handleInvalidInputs(field);
						isValid = false;
					}
					break;
				case 'min_daily_charge_utilization':
				case 'min_daily_charge_ah_utilization':
				case 'min_daily_charge_kwh_utilization':
					if (newValue < 0 || newValue > 100) {
						this.handleInvalidInputs(field);
						isValid = false;
					}
					break;
				case 'max_disconnect_days':
					if (newValue < 0) {
						this.handleInvalidInputs(field);
						isValid = false;
					}
					break;
				case 'minimum_charger_daily_ahr_usage':
					if (newValue < 0 || newValue % 25 !== 0) {
						this.handleInvalidInputs(field);
						isValid = false;
					}
					break;
				case 'low_disconnect_range_min':
				case 'minimum_charger_daily_kwh_usage':
				case 'maximum_charger_daily_kw_demand':
				case 'geofence_distance':
					if (newValue < 1) {
						this.handleInvalidInputs(field);
						isValid = false;
					}
					break;
				case 'low_disconnect_range_max':
					if (newValue < (this.chargerSettings.low_disconnect_range_min + 1)) {
						this.handleInvalidInputs(field);
						isValid = false;
					}
					break;
				case 'mid_disconnect_range_min':
					// Mid min must be >= Low max + 1 to prevent overlap
					if (newValue < (this.chargerSettings.low_disconnect_range_max + 1)) {
						this.handleInvalidInputs(field);
						isValid = false;
					}
					break;
				case 'mid_disconnect_range_max':
					if (newValue < (this.chargerSettings.mid_disconnect_range_min + 1)) {
						this.handleInvalidInputs(field);
						isValid = false;
					}
					break;
				case 'high_disconnect_limit':
					// High limit must be >= Mid max + 1 to prevent overlap
					if (newValue < (this.chargerSettings.mid_disconnect_range_max + 1)) {
						this.handleInvalidInputs(field);
						isValid = false;
					}
					break;
			}
		}
		this.disableButton = !isValid;
	}

	handleInvalidInputs(field: string): boolean {
		const form = this.elementRef.nativeElement;
		const ele = form.querySelectorAll(`[name=${field}]`);
		if(ele && ele[0])
			this.render.addClass(ele[0], 'invalid-input');
		return this.disableButton = true;
	}

	onCheckboxChange(value: number, checked: boolean) {
		this.selectedDays = checked ? [...this.selectedDays, value] : this.selectedDays.filter(day => day !== value);
		this.disableButton = this.selectedDays.length == 0 ? true : false;
	}

	isChecked(dayId: number) {
		return this.selectedDays.includes(dayId);
	}

	ngOnDestroy() {
		this.subSite.unsubscribe();
	}
}
